import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { AttachmentState } from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { isSmimeAttachment } from 'owa-attachment-model-store/lib/utils/isSmimeAttachmentType';
import { isInvalidInlineAttachment } from 'owa-smime-adapter/lib/utils/smimeUtils';

/**
 * Gets the list of all valid attachments to process
 * @param attachmentWell is the attachment well in composeViewState
 * @param content is the email body
 * @param bodyType is text/html
 * @param filterSmimeAttachment true if S/MIME attachments are required, false if non-S/MIME attachments are required
 */
const getAllValidAttachments = (
    attachmentWell: AttachmentWellViewState,
    content: string,
    bodyType: string,
    filterSmimeAttachment: boolean
): AttachmentState[] => {
    if (attachmentWell) {
        const { docViewAttachments, imageViewAttachments, inlineAttachments } = attachmentWell;
        const validInlineAttachments = inlineAttachments.filter(attachment => {
            const attachmentModel = getAttachment(attachment.attachmentId);
            if (attachmentModel && attachmentModel.model && bodyType === 'HTML') {
                const bodyHtml = content;
                return bodyHtml && !isInvalidInlineAttachment(bodyHtml, attachmentModel.model);
            }
            return false;
        });
        const validAttachments = [
            ...docViewAttachments,
            ...imageViewAttachments,
            ...validInlineAttachments,
        ];
        if (filterSmimeAttachment) {
            return validAttachments.filter(attachmentState =>
                isSmimeAttachment(attachmentState.attachmentId.Id)
            );
        } else {
            return validAttachments.filter(
                attachmentState => !isSmimeAttachment(attachmentState.attachmentId.Id)
            );
        }
    }
    return [];
};

export default getAllValidAttachments;
